<div class="scroll">
  @for (item of items; track $index) {
  <div class="container" (click)="openDetailsDialog(item)">
    <div class="item">
      <img
        class="avatar"
        src="{{ getAvatarUrl(item.user_id) }}"
        nbPopover="User: {{ item.user_id }}"
        nbPopoverTrigger="hover"
      />
      <div class="details">
        <span
          class="text"
          [innerHTML]="'charts.eventFeed.' + item.event_type | translate"
        ></span>

        <span class="text"> {{ "charts.eventFeed.on" | translate }} </span>
        <span class="agent-badge">
          <nb-icon pack="al" icon="orbi"></nb-icon>
          <app-agent-identity-label
            [visualName]="item.bot_visual_name"
            [internalName]="item.bot_name"
            [fallback]="item.bot_id"
            [compact]="true"
          ></app-agent-identity-label>
        </span>
        <span class="text"> {{ "charts.eventFeed.chat" | translate }} </span>
      </div>
      <div class="timestamp">{{ item.ts_event | timeago }}</div>

      <div class="icon {{ item.event_type }}">
        <nb-icon pack="al" [icon]="item.event_type"></nb-icon>
      </div>
    </div>
  </div>
  }
</div>
